import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["header", "content"]

  connect() {
    console.log('About toggle controller connected')
    // Set initial state - show investors content by default
    this.showContent("investors")
  }

  toggle(event) {
    const targetName = event.currentTarget.dataset.target
    console.log('Toggling to:', targetName)
    this.showContent(targetName)
  }

  showContent(targetName) {
    // Hide all content sections
    this.contentTargets.forEach(content => {
      content.style.display = "none"
    })

    // Remove active class from all headers and reset border
    this.headerTargets.forEach(header => {
      header.classList.remove("active")
      header.style.borderBottom = "3px solid transparent"
    })

    // Show selected content
    const selectedContent = document.getElementById(`${targetName}-content`)
    if (selectedContent) {
      selectedContent.style.display = "block"
    }

    // Add active class to selected header and apply active border
    const selectedHeader = this.headerTargets.find(header => 
      header.dataset.target === targetName
    )
    if (selectedHeader) {
      selectedHeader.classList.add("active")
      selectedHeader.style.borderBottom = "3px solid #CA2A4C"
    }
  }
}
